import { render, staticRenderFns } from "./VDialogAccountDel.vue?vue&type=template&id=dd777f4c"
import script from "./VDialogAccountDel.vue?vue&type=script&lang=js"
export * from "./VDialogAccountDel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports